import React from "react";
import { Link } from "react-router-dom";
import { AlertTriangle, Lock, CreditCard } from "lucide-react";
import { useAuth } from "../../hooks/useAuth";

const SubscriptionBanner = () => {
  const { companyInfo } = useAuth();

  // Se não tiver dados ou assinatura, não mostra nada (ou mostra trial se for o caso)
  if (!companyInfo?.subscription) return null;

  const { status, trialExpiresAt } = companyInfo.subscription;

  // Datas para cálculo de Trial
  const now = new Date();
  const trialEnd = trialExpiresAt?.toDate ? trialExpiresAt.toDate() : null;
  const daysToTrialEnd = trialEnd
    ? Math.ceil((trialEnd - now) / (1000 * 60 * 60 * 24))
    : 0;

  // 1. CASO: TRIAL ACABANDO (Faltam 3 dias ou menos)
  if (status === "trial" && daysToTrialEnd <= 3 && daysToTrialEnd > 0) {
    return (
      <div className="bg-blue-600 text-white px-4 py-3 shadow-md relative flex items-center justify-between animate-in slide-in-from-top-2">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-white/20 rounded-full">
            <CreditCard className="w-5 h-5 text-white" />
          </div>
          <div>
            <p className="font-bold text-sm">
              Seu período de teste acaba em {daysToTrialEnd} dias!
            </p>
            <p className="text-xs text-blue-100">
              Assine agora para não perder o acesso.
            </p>
          </div>
        </div>
        <Link
          to="/dashboard/assinatura"
          className="bg-white text-blue-600 px-4 py-2 rounded-lg text-xs font-bold hover:bg-blue-50 transition-colors"
        >
          Escolher Plano
        </Link>
      </div>
    );
  }

  // 2. CASO: ATRASADO (Past Due) - Tarja Amarela
  // Ocorre quando o Asaas manda o evento PAYMENT_OVERDUE
  if (status === "past_due") {
    return (
      <div className="bg-yellow-500 text-white px-4 py-3 shadow-md relative flex items-center justify-between animate-in slide-in-from-top-2">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-black/10 rounded-full">
            <AlertTriangle className="w-5 h-5 text-white" />
          </div>
          <div>
            <p className="font-bold text-sm">
              Atenção: Identificamos uma pendência financeira.
            </p>
            <p className="text-xs text-yellow-50">
              Evite o bloqueio dos seus serviços. Regularize sua fatura.
            </p>
          </div>
        </div>
        <Link
          to="/dashboard/assinatura"
          className="bg-white text-yellow-600 px-4 py-2 rounded-lg text-xs font-bold hover:bg-yellow-50 transition-colors"
        >
          Ver Fatura
        </Link>
      </div>
    );
  }

  // 3. CASO: BLOQUEADO/CANCELADO - Tarja Vermelha
  // Ocorre quando passa do limite de dias ou é cancelado manualmente
  if (status === "canceled" || status === "expired_trial") {
    return (
      <div className="bg-red-600 text-white px-4 py-3 shadow-md relative flex items-center justify-between animate-in slide-in-from-top-2">
        <div className="flex items-center gap-3">
          <div className="p-2 bg-black/10 rounded-full">
            <Lock className="w-5 h-5 text-white" />
          </div>
          <div>
            <p className="font-bold text-sm">Acesso Suspenso.</p>
            <p className="text-xs text-red-100">
              Sua assinatura está inativa. Funcionalidades foram bloqueadas.
            </p>
          </div>
        </div>
        <Link
          to="/dashboard/assinatura"
          className="bg-white text-red-600 px-4 py-2 rounded-lg text-xs font-bold hover:bg-red-50 transition-colors"
        >
          Reativar Agora
        </Link>
      </div>
    );
  }

  return null; // Se estiver 'active', não mostra nada.
};

export default SubscriptionBanner;
